<template>
  <div class="c-more">
    <img class="c-more__img" src="@/assets/myMusic/icon_more.svg" @click.stop="handleShowFunction(true)" />

    <n-collapse-transition :show="showFunction">
      <div class="more-list-wrap" v-click-away="() => handleShowFunction(false)">
        <ul class="more-list">
          <template v-for="item of list" :key="item.key">
            <li class="more-list__item" v-if="!item.hide" @click="handleClick(item)">
              <span>{{ item.label }}</span>
              <img v-show="item.type === 'modal'" src="@/assets/global/icon_arrow.svg" />
            </li>
          </template>
        </ul>
      </div>
    </n-collapse-transition>

    <n-modal v-model:show="modelStatus['note']" preset="dialog" :show-icon="false">
      <model-base-layout title="" decoLine>
        <note />
      </model-base-layout>
    </n-modal>

    <n-modal v-model:show="modelStatus['add']" preset="dialog" :show-icon="false">
      <model-base-layout :title="$t('myMusic.moveToPlaylists')" decoLine>
        <add type="TRACK" :data="data" />
      </model-base-layout>
    </n-modal>

    <n-modal v-model:show="modelStatus['move-to-playlists']" preset="dialog" :show-icon="false">
      <model-base-layout :title="$t('myMusic.moveToPlaylists')" decoLine>
        <move-to-playlists />
      </model-base-layout>
    </n-modal>
  </div>
</template>
<script>
import {
  defineComponent, ref, reactive, computed,
} from 'vue';
import { NCollapseTransition, NModal, useMessage } from 'naive-ui';
import { useRouter } from 'vue-router';
// import { v4 as uuid } from 'uuid';
import { useI18n } from 'vue-i18n';
// import { useMusicPlayerStore } from '@/store/musicPlayer';
import ModelBaseLayout from '@/components/Global/Popup/ModelBaseLayout.vue';
import Add from '@/components/Global/Popup/Add.vue';
import Note from '@/components/Global/Popup/Note.vue';
import MoveToPlaylists from '@/components/Global/Popup/MoveToPlaylists.vue';
import useMusicPlayer from '@/hooks/useMusicPlayer';
// import trackWaveSource from '@/utils/trackWaveSource';
import useMemberLevel from '@/hooks/useMemberLevel';

export default defineComponent({
  name: 'MusicMore',
  props: {
    functionList: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
  components: {
    NCollapseTransition,
    NModal,
    ModelBaseLayout,
    Add,

    Note,
    MoveToPlaylists,
  },

  setup(props) {
    window.$message = useMessage();
    const { t } = useI18n();
    const { memberLevel } = useMemberLevel();
    const { isAppend, handleFromExternalTrack } = useMusicPlayer();
    isAppend.value = true;
    const router = useRouter();
    // const message = useMessage();
    // const musicPlayerStore = useMusicPlayerStore();

    const expandStatus = ref(false);
    const showFunction = ref(false);

    const list = computed(() => [
      {
        key: 'to-album-page',
        type: 'route',
        route: {
          name: 'explore-albums-info',
          params: {
            id: props.data.albumUid || props.data.url,
          },
        },
        label: `${t('myMusic.toAlbumPage')}`,
      },
      {
        key: 'add-to-queue',
        type: 'function',
        label: t('myMusic.addToQueue'),
        hide: memberLevel.value <= 2,
      },
      // {
      //   key: 'edit-playlist-name',
      //   type: 'modal',
      //   modalKey: 'add',
      //   label: '加入專案',
      //   hide: memberLevel.value <= 2,
      // },
    ]);

    const modelStatus = reactive({
      note: false,
      add: false,
      'move-to-playlists': false,
    });

    const activityShareRecordTab = ref('share');

    const handleShowFunction = (status) => {
      showFunction.value = status;
    };

    // const handleAppendToPlayQueue = () => {
    //   musicPlayerStore.handleAppendToPlayQueue([{
    //     duration: props.data?.duration,
    //     id: `${props.data?.albumCode}-${props.data?.trackNumber}`,
    //     title: props.data?.trackTitleDisplay,
    //     artworkInfo: props.data?.artworkInfo,
    //     albumInfo: {
    //       albumCoverUrl: props.data?.artworkInfo,
    //       albumName: props.data?.albumTitleDisplay,
    //       albumUid: props.data?.albumUid,
    //       songName: props.data?.trackTitleDisplay,
    //       creator: props.data?.albumCode,
    //       duration: props.data?.duration,
    //       trackUid: props.data?.trackUid,
    //       trackNumber: props.data?.trackNumber,
    //       trackWave: trackWaveSource(props.data?.trackWave),
    //       uuid: uuid(),
    //     },
    //   }]);
    //   // message.success(t('global.addSuccess'));
    // };

    const handleClick = (data) => {
      if (data.type === 'route') {
        router.push(data.route);
      }

      if (data.type === 'function') {
        switch (props.type) {
          case 'theme':
            handleFromExternalTrack(props.data.originUid);
            break;
          default:
            // handleAppendToPlayQueue();
            break;
        }
      }

      if (data.type === 'modal') {
        modelStatus[data.modalKey] = true;
        handleShowFunction(false);
      }
    };

    return {
      modelStatus,
      handleClick,
      list,
      expandStatus,
      handleShowFunction,
      activityShareRecordTab,
      showFunction,

    };
  },
});
</script>
<style lang="scss" scoped>
.c-more {
  position: relative;

  &__img {
    cursor: pointer;
    width: 16px;
  }
}

.more-list-wrap {
  @include position(tr, 100%, 0%);
  @include flex(center);
  @include padding(20px 0);
  width: 160px;
  background-color: $c-white;
  border-radius: 10px;
  box-shadow: 0px 0px 5px #00000029;
  z-index: 10;
}

.more-list {
  &__item {
    @include flex(space-between);
    @include font-style($c-assist4, 14, 400, 0.8px, 24px);
    cursor: pointer;

    &+& {
      margin-top: 12px;
    }
  }
}

@media screen and (min-width: $pc) {
  .more-list-wrap {
    @include position(tl, 100%, 0);
  }
}
</style>
